export class JobInputParamsDto {
  jobIdentity!: string;
  userId!: string;
  userName!: string;
  teamName!: string;
  teamId!:string;
  fileStorageRegionId!:string;
}
